import React, { useEffect } from "react";
import { } from "@material-ui/core";
import { Checkbox, FormControlLabel, FormGroup, makeStyles, styled, Switch, TableCell, TableRow } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    checkbox: {
        color: "#808080",
        '&.Mui-checked': {
            color: "#E60001",
        },
    },
    FormGroup:{
        display: 'flex',
         justifyContent: 'center', 
         alignItems: 'center',
          width: '100%',
          [theme.breakpoints.down("500")]: {
            justifyContent: 'flex-start', 
        },
    }
}))

export default function Index({ keysStock, data, handelChange }) {

    let classes = useStyles();
    const [flag, setFlag] = React.useState(false);


    return (
        <div className={classes['root']}>
            <FormGroup
                row
                className={classes['FormGroup']}
                style={{ }}

            >
                <FormControlLabel control={

                    <Checkbox
                        className={classes['checkbox']}
                        checked={keysStock[data?.key]}
                        onChange={(e) => handelChange(data?.key, e.target.checked)}
                    />
                }
                    label={data?.label}
                />
            </FormGroup>
        </div>)
}
